import { Component, OnDestroy, OnInit, Injectable, Inject } from '@angular/core';
import { ApiService } from '../../Services/api.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { MQTTservicesService } from '../../Services/mqqt-services.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import * as L from 'leaflet';
import 'leaflet-routing-machine';
import { GlobalService } from '../../Services/global.service';
import {
  IMqttMessage,
  MqttModule,
  MQTT_SERVICE_OPTIONS,
  MqttClientService
} from 'ngx-mqtt';
import { CommonModule, DOCUMENT } from '@angular/common';
import { Console } from 'console';
import { environment } from '../../../environments/environment';
import 'leaflet-rotatedmarker';


 

@Component({
  selector: 'app-master-tracking',
  // standalone: true,
  // imports: [CommonModule, RouterOutlet, MqttModule],
  providers: [MqttModule],
  templateUrl: './master-tracking.component.html',
  styleUrl: './master-tracking.component.scss'
})
export class MasterTrackingComponent implements OnInit, OnDestroy {
  map: any = '';
  routingControl: L.Routing.Control | null = null;
  orderTrack: any = {};
  phoneDevice: boolean = false
  is_task: any = {}
  isLoading = true;
  taskCompleted: boolean = false;
  taskCancelled: boolean = false;
  panelCollapsed: boolean = false;
  showUpdatePulse: boolean = false;
  private updatePulseTimer: any = null;

  togglePanel(): void {
    this.panelCollapsed = !this.panelCollapsed;
    if (this.map) {
      const step = () => this.map.invalidateSize({ animate: false });
      // Continuously resize the map during the 450ms CSS transition
      const id = setInterval(step, 30);
      setTimeout(() => { clearInterval(id); step(); }, 500);
    }
  }

  triggerUpdatePulse(): void {
    this.showUpdatePulse = true;
    if (this.updatePulseTimer) clearTimeout(this.updatePulseTimer);
    this.updatePulseTimer = setTimeout(() => {
      this.showUpdatePulse = false;
    }, 2500);
  }

  taskReturned: boolean = false;
  totalDuration: any = ''
  latlngObj: any = []
  desktopDevice: boolean = false
  is_sailer_information: boolean = false
  private bookingMqtt: Subscription = new Subscription
  driverId: string = ''
  companyURL: string = ''

  private subscriptionDriver: Subscription = new Subscription;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private callMethod: ApiService,
    private route: ActivatedRoute,
    private _router: Router,
    private titleService: Title,
    public mqtt: MQTTservicesService,
    public global: GlobalService,
    public messageService: MessageService
  ) {

  }
  shortId: any
  if_mqtt_fier: boolean = true;
  mapBookingData: any = [];
  driverMarkersMap: { [driverId: string]: L.Marker } = {};

  ngOnInit(): void {
    setTimeout(() => {
      this.isLoading = false;
    }, 2000);
    this.route.params.subscribe(params => {
      console.log('PAARAMS ID', params)
      this.shortId = params['id']; // Access the 'id' parameter from the URL
      console.log('Test ID:', this.shortId);
    });

    // this.initMap();

    // console.log(':::::::: task id',  this.orderTrack.task.taskId  )
    this.trackData();

    console.log(':::::::::::::::::::::::::: this.orderTrack ::::::::::::::::::::::::::', this.orderTrack);
    if (this.orderTrack?.task?.taskType == 1) { // PICKUP OR DROP
      if (this.orderTrack.task.isPickupOrDrop == 0) { // both
        this.is_sailer_information = true
        this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---'
        this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---'
        this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'

        this.is_task.sailerName = this.orderTrack.task.pickupRecipientName ? this.orderTrack.task.pickupRecipientName : '---'
        this.is_task.sailerNumber = this.orderTrack.task.pickupRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---'

      } else if (this.orderTrack.task.isPickupOrDrop == 1) { //pickup
        this.is_task.recipientName = this.orderTrack.task.pickupRecipientName ? this.orderTrack.task.pickupRecipientName : '---'
        this.is_task.recipientNumber = this.orderTrack.task.pickupRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---'
        this.is_task.dropoffAddress = this.orderTrack.task.pickupAddress ? this.orderTrack.task.pickupAddress : '---'

      } else if (this.orderTrack.task.isPickupOrDrop == 2) { // drop
        this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---'
        this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---'
        this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'

      }

    } else if (this.orderTrack?.task?.taskType == 2) { // appointment
      this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---',
        this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.pickupRecipientPhone : '---',
        this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'


    } else if (this.orderTrack?.task?.taskType == 3) { //field_workforce
      this.is_task.recipientName = this.orderTrack.task.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : '---',
        this.is_task.recipientNumber = this.orderTrack.task.dropoffRecipientPhone ? '+' + this.orderTrack.task.dropoffRecipientPhone : '---',
        this.is_task.dropoffAddress = this.orderTrack.task.dropoffAddress ? this.orderTrack.task.dropoffAddress : '---'
    };
    //  console.log(':::::::: task id',  this.orderTrack.task.taskId  

    console.log('-------mqtt:::::::;', this.bookingMqtt)
  }

  ngOnDestroy(): void {
    this.bookingMqtt.unsubscribe();
    this.subscriptionDriver.unsubscribe();
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  taskType: any = ''

  trackData() {
    this.orderTrack = {};
    this.callMethod.getSingleTaskTask({ 'shortId': this.shortId }).subscribe((result: any) => {
      if (!result.status) {
        this._router.navigateByUrl('/error/404');
        console.log('No task found *******************')
        return
      }
      else {
        if (result.status) {
          this.orderTrack = result.data
          this.setTitle(this.orderTrack.organizationName)
          this.setFavicon(environment.favIconBaseUrl + this.orderTrack.favIcon);
          this.companyURL = environment.companyLogoBaseUrl + this.orderTrack.companyLogo;
          this.taskType = this.orderTrack.task.isPickupOrDrop


          let order_status = this.global.task_activity_status_string(result.data.task.taskStatus)
          this.orderTrack.orderStatus = order_status;
          console.log('-------ordertrack driver', this.orderTrack.task?.driver)
          console.log('-------ordertrack driver ID', this.orderTrack.task?.driver?.driverId)
          this.driverId = this.orderTrack.task?.driver?.driverId;

          if (this.orderTrack.task.dropoffCoords && this.orderTrack.task?.isPickupOrDrop == 2 && this.orderTrack.task?.driver?.latLong) {
            console.log('ETA condition 1 ##################')
            this.latlngObj[0] = { lat: this.orderTrack.task.driver.latLong[0], lng: this.orderTrack.task.driver.latLong[1] };
            this.latlngObj[1] = { lat: this.orderTrack.task.dropoffCoords[0], lng: this.orderTrack.task.dropoffCoords[1] };
            this.totalDuration = this.global.getDuration(this.latlngObj);
          }

          if (this.orderTrack.task.pickupCoords && this.orderTrack.task?.isPickupOrDrop == 1 && this.orderTrack.task?.driver?.latLong) {
            this.latlngObj[0] = { lat: this.orderTrack.task.driver.latLong[0], lng: this.orderTrack.task.driver.latLong[1] };
            this.latlngObj[1] = { lat: this.orderTrack.task.pickupCoords[0], lng: this.orderTrack.task.pickupCoords[1] };
            this.totalDuration = this.global.getDuration(this.latlngObj);
          }


          if (this.orderTrack.task?.driver?.latLong && this.orderTrack.task?.dropoffCoords &&
            this.orderTrack.orderStatus?.task_status > 6 && this.orderTrack.task?.driver && this.orderTrack.task?.isPickupOrDrop == 0
          ) {
            // this.latlngObj.remove();
            this.latlngObj = [];
            this.latlngObj[0] = { lat: this.orderTrack.task.driver.latLong[0], lng: this.orderTrack.task.driver.latLong[1] };
            this.latlngObj[1] = { lat: this.orderTrack.task.dropoffCoords[0], lng: this.orderTrack.task.dropoffCoords[1] };
            this.totalDuration = this.global.getDuration(this.latlngObj);
          }
          // this.totalDuration = this.totalDuration.toFixed(1)
          if (this.orderTrack.task?.driver?.latLong && this.orderTrack.task?.dropoffCoords &&
            this.orderTrack.task?.pickupCoords && this.orderTrack.orderStatus?.task_status < 7 &&
            this.orderTrack.task?.driver && this.orderTrack.task?.isPickupOrDrop == 0) {
            // this.latlngObj.remove();
            this.latlngObj = [];
            let pickDropLatLng = [];
            this.latlngObj[0] = { lat: this.orderTrack.task.driver.latLong[0], lng: this.orderTrack.task.driver.latLong[1] };
            this.latlngObj[1] = { lat: this.orderTrack.task.pickupCoords[0], lng: this.orderTrack.task.pickupCoords[1] };

            pickDropLatLng[0] = { lat: this.orderTrack.task.dropoffCoords[0], lng: this.orderTrack.task.dropoffCoords[1] };
            pickDropLatLng[1] = { lat: this.orderTrack.task.pickupCoords[0], lng: this.orderTrack.task.pickupCoords[1] };

            this.totalDuration = Number(this.global.getDuration(this.latlngObj)) + Number(this.global.getDuration(pickDropLatLng));

            if (this.totalDuration != undefined && this.totalDuration != null && typeof this.totalDuration == 'number') {
              this.totalDuration = this.totalDuration.toFixed(1)
            }
            console.log('--------------------- this.totalDuration 184 ---------------------', typeof this.totalDuration)
          }

          this.syncTotalDurationWithTaskStatus(result.data.task.taskStatus);

          if (this.orderTrack.task?.driver) {
            this.driverMapMarker.push({
              "driverId": this.orderTrack.task.driver.driverId,
              "driverName": this.orderTrack.task.driver.driverName,
              "driverEmail": this.orderTrack.task.driver.driverEmail,
              "driverPhone": this.orderTrack.task.driver.driverPhone,
              "driverEmployeeId": this.orderTrack.task.driver.driverEmployeeId,
              "latLong": [
                this.orderTrack.task.driver?.latLong ? this.orderTrack.task.driver.latLong[0] : 0,
                this.orderTrack.task.driver?.latLong ? this.orderTrack.task.driver.latLong[1] : 0
              ]
            })
          };
          console.log('----------- pickup111', this.orderTrack.task.pickupCoords);
          console.log('----------- drop111', this.orderTrack.task.dropoffCoords);

          if (this.orderTrack?.task?.pickupCoords.length > 0) {
            console.log('pickup coords', this.orderTrack.task.pickupCoords)
            this.mapBookingData.push({
              "pickupNote": this.orderTrack.task.pickupNote ? this.orderTrack.task.pickupNote : 'NA',
              "coords": [this.orderTrack.task.pickupCoords[0], this.orderTrack.task.pickupCoords[1]],
              "pickupAddress": this.orderTrack.task.pickupAddress ? this.orderTrack.task.pickupAddress : 'NA',
              "pickupRecipientName": this.orderTrack.task.pickupRecipientName ? this.orderTrack.task.pickupRecipientName : 'NA',
              "pickupRecipientEmail": this.orderTrack.task.pickupRecipientEmail ? this.orderTrack.task.pickupRecipientEmail : 'NA',
              "pickupRecipientPhone": this.orderTrack.task.pickupRecipientPhone ? this.orderTrack.task.pickupRecipientPhone : 'NA',
            });
          };

          if (this.orderTrack?.task?.dropoffCoords.length > 0) {
            this.mapBookingData.push({
              "dropoffNote": this.orderTrack.task?.dropoffNote ? this.orderTrack.task.dropoffNote : 'NA',
              "coords":
                [this.orderTrack.task.dropoffCoords[0], this.orderTrack.task.dropoffCoords[1]],
              "dropoffAddress": this.orderTrack.task?.dropoffAddress ? this.orderTrack.task.dropoffAddress : 'NA',
              "dropoffRecipientName": this.orderTrack.task?.dropoffRecipientName ? this.orderTrack.task.dropoffRecipientName : 'NA',
              "dropoffRecipientEmail": this.orderTrack.task?.dropoffRecipientEmail ? this.orderTrack.task.dropoffRecipientEmail : 'NA',
              "dropoffRecipientPhone": this.orderTrack.task?.dropoffRecipientPhone ? this.orderTrack.task.dropoffRecipientPhone : 'NA',
            })
          }
          console.log('--------------------- this.orderTrack ---------------------', this.orderTrack);
          let innerWidth = window.innerWidth;

          if (innerWidth < 1000) {
            this.phoneDevice = true
          } else {
            this.desktopDevice = true;
          }

          console.log('---------------------this.orderTrack.orderStatus?.task_status', this.orderTrack.orderStatus?.task_status)

          const ts = this.orderTrack.orderStatus?.task_status;
          this.initMap();
          this.addMarkers();
          this.adjustMapView();
          if (ts == 9) { this.taskCompleted = true; }
          if (ts == 10 || ts == 11) { this.taskCancelled = true; }
          if (ts == 16) { this.taskReturned = true; }
          this.mqttHandler()
        }
      }
    })
  }

  mqttHandler() {
    console.log('------ mqtt handler------');
    console.log('|| driverId ||||', this.driverId);
    console.log('************', this.orderTrack.parentUserId);

    this.subscriptionDriver = this.mqtt.topic("track_driver_" + this.orderTrack.parentUserId + '/#').pipe(takeUntil(this.unsubscribe)).subscribe((data: IMqttMessage) => {
      console.log('----- mqtt driver update ----');
      let item = JSON.parse(data.payload.toString());
      console.log('|||||------', item);
      if (this.orderTrack.orderStatus?.task_status != 10 && this.orderTrack.orderStatus?.task_status != 11 && this.orderTrack.orderStatus?.task_status != 9) {
        this.updateDriverLocation(item);
        // Tooltips are now static labels without duration - duration is shown in top left corner
      }
    });

    console.log("++++++track_" + this.orderTrack.task.taskId + '/#');
    this.bookingMqtt = this.mqtt.topic("track_" + this.orderTrack.task.taskId + '/#').subscribe((data: IMqttMessage) => {
      let mqtt_update = JSON.parse(data.payload.toString());
      this.if_mqtt_fier = true;

      if (mqtt_update.data.timeline) {
        this.orderTrack.timeline.push(mqtt_update.data.timeline);
      }

      const timelineStatus = mqtt_update.data.timeline?.status;
      const toastInfo = this.getToastForStatus(timelineStatus, mqtt_update.data.timeline?.purpose);

      if (timelineStatus && timelineStatus != 14 && timelineStatus != 16) {
        let order_status = this.global.task_activity_status_string(mqtt_update.data.taskStatus);
        this.orderTrack.orderStatus = order_status;
        this.recalcETA(mqtt_update.data);
      }

      // Status 104: task re-assigned externally
      if (mqtt_update.data.status == 104) {
        this.showToast('warn', 'Task Re-assigned', 'This task has been re-assigned. Refreshing...');
        setTimeout(() => location.reload(), 2000);
        return;
      }

      // Task completed (status 9) — update inline, no reload
      if (timelineStatus == 9) {
        this.taskCompleted = true;
        this.taskCancelled = false;
        this.taskReturned = false;
        this.totalDuration = '';
        let order_status = this.global.task_activity_status_string(9);
        this.orderTrack.orderStatus = order_status;
        this.showToast('success', 'Delivery Complete', 'Your order has been delivered successfully!');
        return;
      }

      // Cancelled (status 10 or 11) — update inline, no reload
      if (timelineStatus == 10 || timelineStatus == 11) {
        this.taskCancelled = true;
        this.taskCompleted = false;
        this.taskReturned = false;
        this.totalDuration = '';
        let order_status = this.global.task_activity_status_string(timelineStatus);
        this.orderTrack.orderStatus = order_status;
        const actor = timelineStatus == 10 ? 'user' : 'driver';
        this.showToast('error', 'Task Cancelled', `This task was cancelled by the ${actor}.`);
        return;
      }

      // Returned (status 16) — update inline, no reload
      if (timelineStatus == 16) {
        this.taskReturned = true;
        this.taskCompleted = false;
        this.taskCancelled = false;
        this.totalDuration = '';
        let order_status = this.global.task_activity_status_string(16);
        this.orderTrack.orderStatus = order_status;
        this.showToast('warn', 'Order Returned', 'The package has been returned to sender.');
        return;
      }

      // Re-scheduled (status 14) — rebuild map markers with new driver/task
      if (timelineStatus == 14) {
        this.handleReschedule(mqtt_update.data);
        this.showToast('info', 'Re-scheduled', 'Your delivery has been re-scheduled with a new driver.');
        return;
      }

      // All other live status updates — show contextual toast
      this.showToast(toastInfo.severity, toastInfo.summary, toastInfo.detail);
      this.triggerUpdatePulse();
    });
  };

  private getToastForStatus(status: number, purpose?: string): { severity: string; summary: string; detail: string } {
    switch (status) {
      case 1:  return { severity: 'info',    summary: 'Order Created',        detail: 'Your task has been created and is being processed.' };
      case 2:  return { severity: 'info',    summary: 'Driver Assigned',      detail: 'A driver has been assigned to your task.' };
      case 3:  return { severity: 'success', summary: 'Driver Accepted',      detail: 'Your driver has accepted the delivery.' };
      case 4:  return { severity: 'info',    summary: 'On the Way',           detail: 'Driver is heading to the pickup location.' };
      case 5:  return { severity: 'info',    summary: 'Arrived at Pickup',    detail: 'Driver has arrived at the pickup point.' };
      case 6:  return { severity: 'success', summary: 'Pickup Complete',      detail: 'Package has been picked up successfully.' };
      case 7:  return { severity: 'info',    summary: 'In Transit',           detail: 'Driver is on the way to the drop-off.' };
      case 8:  return { severity: 'info',    summary: 'Arrived at Drop-off',  detail: 'Driver has arrived at the delivery location.' };
      case 9:  return { severity: 'success', summary: 'Delivered',            detail: 'Your order has been delivered!' };
      case 10: return { severity: 'error',   summary: 'Cancelled',            detail: 'Order cancelled by customer.' };
      case 11: return { severity: 'error',   summary: 'Cancelled',            detail: 'Order cancelled by driver.' };
      case 12: return { severity: 'info',    summary: 'Planning Route',       detail: 'Route is being planned for delivery.' };
      case 13: return { severity: 'info',    summary: 'Route Planned',        detail: 'Delivery route has been finalized.' };
      case 14: return { severity: 'warn',    summary: 'Re-scheduled',         detail: 'Delivery has been re-scheduled.' };
      case 16: return { severity: 'warn',    summary: 'Returned',             detail: 'Package returned to sender.' };
      default: return { severity: 'info',    summary: 'Update',               detail: purpose || 'Task status updated.' };
    }
  }

  private showToast(severity: string, summary: string, detail: string): void {
    this.messageService.clear();
    this.messageService.add({ severity, summary, detail, life: 4000, key: 'wf-toast' });
  }

  private recalcETA(mqData: any): void {
    const tStatus = mqData.timeline?.status;
    if (!mqData.driver?.latLong) return;

    if (mqData.pickupCoords && tStatus < 7 && mqData.isPickupOrDrop == 1) {
      this.latlngObj = [
        { lat: mqData.driver.latLong[0], lng: mqData.driver.latLong[1] },
        { lat: mqData.pickupCoords[0], lng: mqData.pickupCoords[1] }
      ];
      this.totalDuration = this.global.getDuration(this.latlngObj);
    }

    if (mqData.dropoffCoords && tStatus > 6 && mqData.isPickupOrDrop == 2) {
      this.latlngObj = [
        { lat: mqData.driver.latLong[0], lng: mqData.driver.latLong[1] },
        { lat: mqData.dropoffCoords[0], lng: mqData.dropoffCoords[1] }
      ];
      this.totalDuration = this.global.getDuration(this.latlngObj);
    }

    if (mqData.dropoffCoords && tStatus > 6) {
      this.latlngObj = [
        { lat: mqData.driver.latLong[0], lng: mqData.driver.latLong[1] },
        { lat: mqData.dropoffCoords[0], lng: mqData.dropoffCoords[1] }
      ];
      this.totalDuration = this.global.getDuration(this.latlngObj);
    }

    if (mqData.driver?.latLong && mqData.dropoffCoords?.length > 0 && mqData.pickupCoords?.length > 0 && tStatus < 7) {
      const driverToPickup = [
        { lat: mqData.driver.latLong[0], lng: mqData.driver.latLong[1] },
        { lat: mqData.pickupCoords[0], lng: mqData.pickupCoords[1] }
      ];
      const pickupToDrop = [
        { lat: mqData.dropoffCoords[0], lng: mqData.dropoffCoords[1] },
        { lat: mqData.pickupCoords[0], lng: mqData.pickupCoords[1] }
      ];
      this.totalDuration = Number(this.global.getDuration(driverToPickup)) + Number(this.global.getDuration(pickupToDrop));
      if (typeof this.totalDuration == 'number') {
        this.totalDuration = this.totalDuration.toFixed(1);
      }
    }
    const taskStatus = mqData.taskStatus ?? this.orderTrack?.orderStatus?.task_status ?? 0;
    this.syncTotalDurationWithTaskStatus(taskStatus);
    this.triggerUpdatePulse();
  }

  private syncTotalDurationWithTaskStatus(taskStatus: number): void {
    if (taskStatus < 4) {
      this.totalDuration = '';
    }
  }

  private handleReschedule(mqData: any): void {
    if (this.driverMarkersMap[this.orderTrack.task?.driver?.driverId]) {
      this.map.removeLayer(this.driverMarkersMap[this.orderTrack.task.driver.driverId]);
    }

    this.orderTrack.task = mqData.task;

    if (this.driverPolylinesMap) {
      this.driverPolylinesMap.forEach((polyline: L.Polyline) => this.map.removeLayer(polyline));
    }
    if (this.bookingMarkers) {
      this.bookingMarkers.forEach((marker: any) => this.map.removeLayer(marker));
    }

    this.mapBookingData = [];
    this.bookingMarkers = [];
    this.driverMapMarker = [];
    this.driverPolylinesMap = [];

    this.driverId = this.orderTrack.task?.driver?.driverId;
    if (this.orderTrack.task.driver) {
      this.driverMapMarker.push({
        driverId: this.orderTrack.task.driver.driverId,
        driverName: this.orderTrack.task.driver.driverName,
        driverEmail: this.orderTrack.task.driver.driverEmail,
        driverPhone: this.orderTrack.task.driver.driverPhone,
        driverEmployeeId: this.orderTrack.task.driver.driverEmployeeId,
        latLong: [
          this.orderTrack.task.driver?.latLong?.[0] || 0,
          this.orderTrack.task.driver?.latLong?.[1] || 0
        ]
      });
    }

    if (this.orderTrack?.task?.pickupCoords?.length > 0) {
      this.mapBookingData.push({
        pickupNote: this.orderTrack.task.pickupNote || 'NA',
        coords: [this.orderTrack.task.pickupCoords[0], this.orderTrack.task.pickupCoords[1]],
        pickupAddress: this.orderTrack.task.pickupAddress || 'NA',
        pickupRecipientName: this.orderTrack.task.pickupRecipientName || 'NA',
        pickupRecipientEmail: this.orderTrack.task.pickupRecipientEmail || 'NA',
        pickupRecipientPhone: this.orderTrack.task.pickupRecipientPhone || 'NA',
      });
    }

    if (this.orderTrack?.task?.dropoffCoords?.length > 0) {
      this.mapBookingData.push({
        dropoffNote: this.orderTrack.task.dropoffNote || 'NA',
        coords: [this.orderTrack.task.dropoffCoords[0], this.orderTrack.task.dropoffCoords[1]],
        dropoffAddress: this.orderTrack.task.dropoffAddress || 'NA',
        dropoffRecipientName: this.orderTrack.task.dropoffRecipientName || 'NA',
        dropoffRecipientEmail: this.orderTrack.task.dropoffRecipientEmail || 'NA',
        dropoffRecipientPhone: this.orderTrack.task.dropoffRecipientPhone || 'NA',
      });
    }

    this.recalcETA({
      driver: this.orderTrack.task.driver,
      dropoffCoords: this.orderTrack.task.dropoffCoords,
      pickupCoords: this.orderTrack.task.pickupCoords,
      timeline: { status: this.orderTrack.orderStatus?.task_status },
      isPickupOrDrop: this.orderTrack.task.isPickupOrDrop
    });

    this.updateBookingMarker();
    this.updateDriverMarker();
  }

  // Event handler to update driver's marker position from locationData
  updateDriverLocation(item: any): void {
    console.log('Trying to update drivers lat-lng', this.driverMarkersMap);
    let driverId = item.driverId;

    if (item.locationData && item.locationData.length > 0) {
      // Process the latest location from locationData
      const location = item.locationData[item.locationData.length - 1]; // Use the last location for smoothness
      const newLatLng = [location.latitude, location.longitude];

      // Get the current marker
      const marker = this.driverMarkersMap[driverId];
      if (!marker) {
        console.warn(`No marker found for driverId: ${driverId}`);
        return;
      }

      // Get current position of the marker
      const currentLatLng = marker.getLatLng();
      console.log('latlng update^^^^^^^', newLatLng[0], newLatLng[1]);

      // Animation parameters
      const duration = 1000; // Animation duration in milliseconds (1 second)
      const steps = 60; // Number of interpolation steps (higher = smoother)
      const stepDuration = duration / steps;

      // Linear interpolation function
      const interpolate = (start: number, end: number, factor: number) => {
        return start + (end - start) * factor;
      };

      // Animate marker movement
      let step = 0;
      const animateMarker = () => {
        // Snap to final position and update ETA/tooltip
        const finalBearing = this.calculateBearing(currentLatLng.lat, currentLatLng.lng, newLatLng[0], newLatLng[1]);
        marker.setLatLng([newLatLng[0], newLatLng[1]]);
        (marker as any).setRotationAngle(finalBearing);
        this.driverMarkersMap[driverId].setLatLng([newLatLng[0], newLatLng[1]]);

        // Recompute total duration from updated driver position
        try {
          let updatedTotal: any = undefined;
          // Before pickup: driver -> pickup (+ pickup -> drop if applicable)
          if (this.orderTrack?.task?.pickupCoords && this.orderTrack?.orderStatus?.task_status < 7) {
            const driverToPickup = [
              { lat: newLatLng[0], lng: newLatLng[1] },
              { lat: this.orderTrack.task.pickupCoords[0], lng: this.orderTrack.task.pickupCoords[1] }
            ];
            updatedTotal = Number(this.global.getDuration(driverToPickup));

            if (this.orderTrack?.task?.dropoffCoords) {
              const pickupToDrop = [
                { lat: this.orderTrack.task.pickupCoords[0], lng: this.orderTrack.task.pickupCoords[1] },
                { lat: this.orderTrack.task.dropoffCoords[0], lng: this.orderTrack.task.dropoffCoords[1] }
              ];
              updatedTotal += Number(this.global.getDuration(pickupToDrop));
            }
          } else if (this.orderTrack?.task?.dropoffCoords) {
            // After pickup: driver -> dropoff
            const driverToDrop = [
              { lat: newLatLng[0], lng: newLatLng[1] },
              { lat: this.orderTrack.task.dropoffCoords[0], lng: this.orderTrack.task.dropoffCoords[1] }
            ];
            updatedTotal = Number(this.global.getDuration(driverToDrop));
          }

          if (updatedTotal !== undefined && updatedTotal !== null && !isNaN(updatedTotal)) {
            this.totalDuration = Number(updatedTotal).toFixed(1);
            this.syncTotalDurationWithTaskStatus(this.orderTrack?.orderStatus?.task_status ?? 0);
            if (this.totalDuration) {
              this.triggerUpdatePulse();
            }
          }

          console.log('updated this.totalDuration^^^^^^^^^^^^^^', this.totalDuration);
        } catch (e) {
          console.warn('ETA update failed:', e);
        }

        const factor = step / steps;
        const interpolatedLat = interpolate(currentLatLng.lat, newLatLng[0], factor);
        const interpolatedLng = interpolate(currentLatLng.lng, newLatLng[1], factor);

        const bearing = this.calculateBearing(currentLatLng.lat, currentLatLng.lng, newLatLng[0], newLatLng[1]);
        console.log('Calculated bearing:', bearing);
        // Update marker position
        marker.setLatLng([interpolatedLat, interpolatedLng]);
        (marker as any).setRotationAngle(bearing);
        this.driverMarkersMap[driverId].setLatLng([interpolatedLat, interpolatedLng]);

        // Increment step and continue animation
        step++;
        if (step < steps) {
          requestAnimationFrame(animateMarker);
        }
      };

      // Start animation
      requestAnimationFrame(animateMarker);

      // Adjust map view to fit the updated driver markers based on task type
      if (this.driverMarkersMap[driverId] && this.bookingMarkers && this.bookingMarkers.length > 0) {
        console.log('booking markers^^^^^^^^^^^^^^', this.bookingMarkers);
        console.log('orderTrack.orderStatus?.task_status^^^^^^^^^^^^^^', this.orderTrack.orderStatus?.task_status);
        console.log('driverMarkersMap^^^^^^^^^^^^^^', this.driverMarkersMap[driverId]);
        console.log('taskType^^^^^^^^^^^^^^', this.taskType);
        
        let bookingMarker;
        if (this.taskType == 1) {
          // Pickup only: always use pickup marker (index 0)
          bookingMarker = this.bookingMarkers[0];
        } else if (this.taskType == 2) {
          // Drop only: always use drop marker (index 0)
          bookingMarker = this.bookingMarkers[0];
        } else if (this.taskType == 0) {
          // Both: use pickup before status 7, drop after
          if (this.orderTrack.orderStatus?.task_status < 7) {
            bookingMarker = this.bookingMarkers[0]; // Pickup marker
          } else {
            bookingMarker = this.bookingMarkers[1]; // Drop-off marker
          }
        }

        if (bookingMarker) {
          // Create a group with the driver marker and booking marker
          const group = new L.FeatureGroup([this.driverMarkersMap[driverId], bookingMarker]);
          this.map.fitBounds(group.getBounds(), { padding: [50, 50], animate: true });
          console.log('group^^^^^^^^^^^^^^', group);
        }
      } else if (this.bookingMarkers && this.bookingMarkers.length > 0) {
        const group = new L.FeatureGroup([...this.bookingMarkers]);
        this.map.fitBounds(group.getBounds(), { padding: [50, 50], animate: true });
      }

      console.log('this.map^^^^^^^^^^^^^^', this.map);
      console.log('this.driverMarkersMap[driverId]^^^^^^^^^^^^^^', this.driverMarkersMap[driverId]);
    }
  }

  calculateBearing(startLat: number, startLng: number, endLat: number, endLng: number): number {
    const toRad = (degrees: number) => (degrees * Math.PI) / 180;
    const toDeg = (radians: number) => (radians * 180) / Math.PI;

    const lat1 = toRad(startLat);
    const lng1 = toRad(startLng);
    const lat2 = toRad(endLat);
    const lng2 = toRad(endLng);

    const dLng = lng2 - lng1;
    const y = Math.sin(dLng) * Math.cos(lat2);
    const x =
      Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);
    const bearing = toDeg(Math.atan2(y, x));
    return (bearing + 360) % 360; // Normalize to 0-360 degrees
  }


  initMap(): void {


    // Initialize the map
    this.map = L.map('map').setView([22.29161, 70.79322], 1); // Set default coordinates and zoom level
    // Add a tile layer from OpenStreetMap or Mapbox
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '© OpenStreetMap contributors'
    }).addTo(this.map);
    // this.adjustMapView();
  }

  copyClipBoard(elementId: string): void {
    var copyText: any = document.getElementById(elementId);
    navigator.clipboard.writeText(copyText.textContent)
      .then(() => {
        this.showToast('success', 'Copied', 'Task ID copied to clipboard');
      })
      .catch(err => console.error("Failed to copy:", err));
  }

  copyClipBoardCustom(elementId: string): void {
    var copyText: any = document.getElementById(elementId);
    navigator.clipboard.writeText(copyText.textContent)
      .then(() => {
        this.showToast('success', 'Copied', 'Custom ID copied to clipboard');
      })
      .catch(err => console.error("Failed to copy:", err));
  }
  driverMapMarker: any = [];
  driverPolylinesMap: L.Polyline[] = [];
  bookingMarkers: L.Marker[] = [];

  // Function to set a new title
  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  // Method to set a new favicon
  public setFavicon(iconUrl: string): void {
    const link: HTMLLinkElement | null = this.document.querySelector("link[rel*='icon']");
    console.log('favUrl ********', iconUrl)
    if (link) {
      // If link already exists, update its href
      link.href = iconUrl;
    } else {
      // If no favicon is set, create a new link tag
      const newLink: HTMLLinkElement = this.document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = iconUrl;
      this.document.head.appendChild(newLink);
    }
  }



  //! old add marker fuction with polyline logic By Prit Dedaniya
  addMarkers(): void {
    console.log('------ drivermapmarker-----', this.driverMapMarker)
    let driverId = this.driverMapMarker[0].driverId;  // Assuming driverId is available here
    // === Handle Driver Marker ===
    if (this.driverMapMarker && this.driverMapMarker.length > 0 && this.orderTrack.task.driver.driverId) {
      console.log('**********', this.driverMapMarker)
      const driverMarkerData = this.driverMapMarker[0]; // Use first driver's data
      if (driverMarkerData && this.driverMarkersMap[driverId]) {
        // Update the marker position if it already exists
        this.driverMarkersMap[driverId].setLatLng([driverMarkerData.latLong[0], driverMarkerData.latLong[1]]);
        // Update the marker icon
        const updatedIcon = L.icon({
          iconUrl: 'images/blueCar.png',
          iconSize: [35,65],
          iconAnchor: [24, 41],
          popupAnchor: [1, -34],
        });
        this.driverMarkersMap[driverId].setIcon(updatedIcon);
      }

      if (driverMarkerData && !this.driverMarkersMap[driverId]) {
        // First-time creation of the driver marker
        const driverIcon = L.icon({
          iconUrl: 'images/blueCar.png',
          iconSize: [35,65],
          iconAnchor: [24, 41],
          popupAnchor: [1, -34]
        });

        const driverMarker = L.marker([driverMarkerData.latLong[0], driverMarkerData.latLong[1]], { icon: driverIcon })
          .addTo(this.map)
          .bindPopup(driverMarkerData.driverName);

        this.driverMarkersMap[driverId] = driverMarker;
      }
    }

    // === Handle Booking Markers ===
    const polylineLatLngs: L.LatLngExpression[] = [];
    console.log('&&&&& mapBookingdata', this.mapBookingData);

    const mkrIcon = (label: string, color: string, ringColor: string) => L.divIcon({
      className: '',
      iconSize: [100, 58],
      iconAnchor: [50, 58],
      popupAnchor: [0, -58],
      html: `
        <div style="display:flex;flex-direction:column;align-items:center;font-family:'Nunito',system-ui,sans-serif;">
          <div style="
            background:${color};
            color:#fff;
            font-size:10.5px;
            font-weight:800;
            letter-spacing:.06em;
            padding:6px 16px;
            border-radius:100px;
            white-space:nowrap;
            text-transform:uppercase;
            box-shadow:0 4px 18px ${color}66, 0 2px 6px ${color}44;
          ">${label}</div>
          <div style="width:2px;height:10px;background:${color};opacity:.5;"></div>
          <div style="
            width:13px;height:13px;border-radius:50%;
            background:${color};
            box-shadow:0 0 0 5px ${ringColor}, 0 2px 8px ${color}55;
          "></div>
        </div>
      `
    });

    if (this.mapBookingData && this.mapBookingData.length > 0) {
      this.mapBookingData.forEach((bookingLocation: any, index: any) => {
        polylineLatLngs.push([bookingLocation.coords[0], bookingLocation.coords[1]]);

        // Determine if this is a pickup or dropoff
        let isPickup = false;
        if (this.taskType === 0) {
          isPickup = index === 0;
        } else if (this.taskType === 1) {
          isPickup = true;
        } else {
          isPickup = false;
        }

        const icon = isPickup
          ? mkrIcon('PICKUP', '#3d52d5', 'rgba(61,82,213,.18)')
          : mkrIcon('DROP-OFF', '#2d6a4f', 'rgba(45,106,79,.18)');

        const bookingMarker = L.marker(
          [bookingLocation.coords[0], bookingLocation.coords[1]],
          { icon }
        ).addTo(this.map)
         .bindPopup(this.createBookingPopupContent(bookingLocation));

        this.bookingMarkers.push(bookingMarker);
      });
    }

    // If there are at least two booking markers, create a polyline between them (only for taskType 0)
    if (this.taskType == 0 && polylineLatLngs.length >= 2) {
      const polyline = L.polyline([polylineLatLngs[0], polylineLatLngs[1]], {
        color: '#3d52d5',
        weight: 2.5,
        opacity: 0.6,
        dashArray: '7, 12'
      }).addTo(this.map);

      this.driverPolylinesMap.push(polyline);
    }

    // Adjust map view based on task type
    if (this.driverMarkersMap[driverId]) {
      if (this.taskType == 1) {
        // Pickup only: fit bounds between driver and pickup marker (index 0)
        if (this.bookingMarkers && this.bookingMarkers.length > 0 && this.bookingMarkers[0]) {
          const group = new L.FeatureGroup([this.driverMarkersMap[driverId], this.bookingMarkers[0]]);
          this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
        }
      } else if (this.taskType == 2) {
        // Drop only: fit bounds between driver and drop marker (index 0)
        if (this.bookingMarkers && this.bookingMarkers.length > 0 && this.bookingMarkers[0]) {
          const group = new L.FeatureGroup([this.driverMarkersMap[driverId], this.bookingMarkers[0]]);
          this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
        }
      } else if (this.taskType == 0) {
        // Both: fit bounds between driver and all booking markers
        if (this.bookingMarkers && this.bookingMarkers.length > 0) {
          const group = new L.FeatureGroup([...this.bookingMarkers, this.driverMarkersMap[driverId]]);
          this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
        }
      }
    } else if (this.bookingMarkers && this.bookingMarkers.length > 0) {
      // Fallback: if no driver marker, just fit booking markers
      const group = new L.FeatureGroup([...this.bookingMarkers]);
      this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
    }
  };


  //! old update marker function with polyline logic By Prit Dedaniya
  updateBookingMarker(): void {
    const polylineLatLngs: L.LatLngExpression[] = [];
    console.log('&&&&& mapBookingdata', this.mapBookingData);

    const mkrIcon = (label: string, color: string, ringColor: string) => L.divIcon({
      className: '',
      iconSize: [100, 58],
      iconAnchor: [50, 58],
      popupAnchor: [0, -58],
      html: `
        <div style="display:flex;flex-direction:column;align-items:center;font-family:'Nunito',system-ui,sans-serif;">
          <div style="
            background:${color};color:#fff;font-size:10.5px;font-weight:800;
            letter-spacing:.07em;padding:6px 16px;border-radius:100px;
            white-space:nowrap;text-transform:uppercase;
            box-shadow:0 4px 18px ${color}66,0 2px 6px ${color}44;
          ">${label}</div>
          <div style="width:2px;height:10px;background:${color};opacity:.5;"></div>
          <div style="width:13px;height:13px;border-radius:50%;background:${color};
            box-shadow:0 0 0 5px ${ringColor},0 2px 8px ${color}55;"></div>
        </div>
      `
    });

    if (this.mapBookingData && this.mapBookingData.length > 0) {
      this.mapBookingData.forEach((bookingLocation: any, index: any) => {
        polylineLatLngs.push([bookingLocation.coords[0], bookingLocation.coords[1]]);

        let isPickup = false;
        if (this.taskType === 0) isPickup = index === 0;
        else if (this.taskType === 1) isPickup = true;
        else isPickup = false;

        const icon = isPickup
          ? mkrIcon('PICKUP', '#3d52d5', 'rgba(61,82,213,.18)')
          : mkrIcon('DROP-OFF', '#2d6a4f', 'rgba(45,106,79,.18)');

        const bookingMarker = L.marker(
          [bookingLocation.coords[0], bookingLocation.coords[1]],
          { icon }
        ).addTo(this.map)
         .bindPopup(this.createBookingPopupContent(bookingLocation));

        this.bookingMarkers.push(bookingMarker);
      });

      // If there are at least two booking markers, create a polyline between them (only for taskType 0)
      if (this.taskType == 0 && polylineLatLngs.length >= 2) {
        const polyline = L.polyline([polylineLatLngs[0], polylineLatLngs[1]], {
          color: '#3d52d5',
          weight: 2.5,
          opacity: 0.6,
          dashArray: '7, 12'
        }).addTo(this.map);

        // Store the polyline if needed
        this.driverPolylinesMap.push(polyline);
      }
    }

    // Adjust map view to fit all markers
    this.adjustMapView();
  }

  updateDriverMarker(): void {
    if (this.driverMapMarker && this.driverMapMarker.length > 0) {
      console.log('**********', this.driverMapMarker)
      const driverMarkerData = this.driverMapMarker[0]; // Use first driver's data
      // if (driverMarkerData && this.driverMarkersMap[this.orderTrack.task.driver.driverId]) {
      //   // Update the marker position if it already exists
      //   this.driverMarkersMap[this.orderTrack.task.driver.driverId].setLatLng([driverMarkerData.latLong[0], driverMarkerData.latLong[1]]);
      //   // Update the marker icon
      //   const updatedIcon = L.icon({
      //     iconUrl: 'images/blueCar.png',
      //     iconSize: [55, 55],
      //     iconAnchor: [12, 41],
      //     popupAnchor: [1, -34],
      //   });
      //   this.driverMarkersMap[this.orderTrack.task.driver.driverId].setIcon(updatedIcon);
      // }

      if (driverMarkerData && this.driverMarkersMap[this.orderTrack.task.driver.driverId]) {
        // First-time creation of the driver marker
        const driverIcon = L.icon({
          iconUrl: 'images/blueCar.png',
          iconSize: [35, 65],
          iconAnchor: [24, 41],
          popupAnchor: [1, -34],
        });
        const driverMarker = L.marker([driverMarkerData.latLong[0], driverMarkerData.latLong[1]], { icon: driverIcon })
          .addTo(this.map)
          .bindPopup(driverMarkerData.driverName);

        this.driverMarkersMap[this.orderTrack.task.driver.driverId] = driverMarker;
      }
    }
  }

  removeBookingMarker(): void {
    console.log('Removing booking markers and polylines');

    // Remove all markers from the map
    this.bookingMarkers.forEach(marker => {
      this.map.removeLayer(marker);
    });


    this.driverPolylinesMap.forEach(polyline => {
      this.map.removeLayer(polyline)
    })

    // Clear the array
    this.bookingMarkers = [];
    this.driverPolylinesMap = [];
  }

  adjustMapView(): void {
    const driverId = this.orderTrack.task?.driver?.driverId;
    if (this.bookingMarkers && this.driverMarkersMap[driverId]) {
      console.log('$$$$$$$$$$$$', this.bookingMarkers)
      console.log(this.driverMarkersMap)
      const allMarkers = Object.values(this.bookingMarkers);
      const driverMarker = Object.values(this.driverMarkersMap[driverId]);
      console.log('::::adjust array', allMarkers);
      console.log('taskType in adjustMapView:', this.taskType);

      let group;
      if (this.taskType == 1) {
        // Pickup only: fit bounds between driver and pickup marker (index 0)
        if (this.bookingMarkers.length > 0 && this.bookingMarkers[0]) {
          group = new L.FeatureGroup([this.driverMarkersMap[driverId], this.bookingMarkers[0]]);
        }
      } else if (this.taskType == 2) {
        // Drop only: fit bounds between driver and drop marker (index 0)
        if (this.bookingMarkers.length > 0 && this.bookingMarkers[0]) {
          group = new L.FeatureGroup([this.driverMarkersMap[driverId], this.bookingMarkers[0]]);
        }
      } else if (this.taskType == 0) {
        // Both: fit bounds between driver and all booking markers
        group = new L.FeatureGroup([this.driverMarkersMap[driverId], ...this.bookingMarkers]);
      }

      if (group) {
        console.log('-------group', group.getBounds())
        this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
      }
    }
    else if (this.bookingMarkers) {
      const group = new L.FeatureGroup([...this.bookingMarkers]);

      console.log('-------group', group.getBounds())
      this.map.fitBounds(group.getBounds(), { padding: [50, 50] });
    }
  }

  get isTerminalState(): boolean {
    const s = this.orderTrack?.orderStatus?.task_status;
    return s == 9 || s == 10 || s == 11 || s == 16;
  }

  get terminalStatusLabel(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 9) return 'Completed';
    if (s == 10) return 'User Cancelled';
    if (s == 11) return 'Driver Cancelled';
    if (s == 16) return 'Order Returned';
    return '';
  }

  get terminalTitle(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 9) return 'Task Completed';
    if (s == 10 || s == 11) return 'Task Cancelled';
    if (s == 16) return 'Order Returned';
    return '';
  }

  get terminalSubtitle(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 9) return 'This order has been delivered successfully.';
    if (s == 10) return 'This order was cancelled by the user.';
    if (s == 11) return 'The driver cancelled this task.';
    if (s == 16) return 'This order has been returned to the sender.';
    return '';
  }

  get terminalBadgeClass(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 9) return 'badge-completed';
    if (s == 10 || s == 11) return 'badge-cancelled';
    if (s == 16) return 'badge-returned';
    return '';
  }

  get terminalIconClass(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 9) return 'bi-check-lg';
    if (s == 10 || s == 11) return 'bi-x-lg';
    if (s == 16) return 'bi-arrow-return-left';
    return '';
  }

  get terminalActorLabel(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    if (s == 10) return 'CANCELLED BY';
    if (s == 11) return 'DRIVER';
    if (s == 16) return 'RETURNED BY';
    if (s == 9) return 'DELIVERED BY';
    return '';
  }

  get terminalActorName(): string {
    return this.orderTrack?.task?.driver?.driverName || '---';
  }

  get terminalTimestamp(): string {
    const tl = this.orderTrack?.timeline;
    if (tl && tl.length > 0) {
      const last = tl[tl.length - 1];
      return last?.displayDate ? this.global.dateFormat(last.displayDate) : '---';
    }
    return '---';
  }

  getStatusSteps(): { label: string; status: 'completed' | 'active' | 'pending' }[] {
    const taskStatus = this.orderTrack?.orderStatus?.task_status || 0;
    const steps = [
      { label: 'Created', minStatus: 1 },
      { label: 'Accepted', minStatus: 3 },
      { label: 'Pickup', minStatus: 6 },
      { label: 'In Transit', minStatus: 7 },
      { label: 'Delivered', minStatus: 9 },
    ];

    return steps.map(step => {
      if (taskStatus >= step.minStatus) {
        if (step.minStatus === 9 && taskStatus === 9) return { label: step.label, status: 'completed' as const };
        if (taskStatus > step.minStatus || (taskStatus === step.minStatus && step.minStatus < 9))
          return { label: step.label, status: 'completed' as const };
        return { label: step.label, status: 'active' as const };
      }
      return { label: step.label, status: 'pending' as const };
    });
  }

  getStatusDescription(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    switch (s) {
      case 1: return 'Order has been created';
      case 2: return 'Driver has been assigned';
      case 3: return 'Driver accepted the order';
      case 4: return 'Heading to Pickup';
      case 5: return 'Driver arrived at pickup';
      case 6: return 'Pickup completed';
      case 7: return 'Heading to Drop-off';
      case 8: return 'Driver arrived at drop-off';
      case 9: return 'Delivery completed';
      case 10: return 'Order cancelled by user';
      case 11: return 'Order cancelled by driver';
      case 12: return 'Route is being planned';
      case 13: return 'Route has been planned';
      case 14: return 'Delivery re-scheduled';
      case 16: return 'Package returned to sender';
      default: return 'Processing order...';
    }
  }

  getStatusSubtext(): string {
    const s = this.orderTrack?.orderStatus?.task_status;
    switch (s) {
      case 4: return 'Driver is on the way to the pickup point';
      case 5: return 'Driver has arrived at the pickup location';
      case 7: return 'Driver is on the way to the drop-off point';
      case 8: return 'Driver has arrived at the drop-off location';
      default: return '';
    }
  }

  getDriverInitial(): string {
    const name = this.orderTrack?.task?.driver?.driverName;
    return name ? name.charAt(0).toUpperCase() : '?';
  }

  getLastUpdateTime(): string {
    const tl = this.orderTrack?.timeline;
    if (tl && tl.length > 0) {
      const last = tl[tl.length - 1];
      return last?.displayDate ? this.global.dateFormat(last.displayDate) : '';
    }
    return '';
  }

  // Helper function to generate booking location popup content
  private createBookingPopupContent(infoWindow: any): string {
    let content = '<table class="driver_details_table fontMedium border-0">';
    if (infoWindow.pickupAddress) {
      content += `<tr><td class="text-center font-semibold"><b>${infoWindow.pickupRecipientName}</b></td></tr>`;
      content += `<tr><td class="text-left">${infoWindow.pickupAddress}</td></tr>`;
    }
    // if (infoWindow.pickupRecipientName) {
    //   content += `<tr><td class="text-left font-semibold"><b>pickupRecipientName:&nbsp;</b></td><td class="text-left">${infoWindow.pickupRecipientName}</td></tr>`;
    // }
    if (infoWindow.dropoffAddress) {
      content += `<tr><td class="text-center font-semibold"><b>${infoWindow.dropoffRecipientName}</b></td></tr>`;
      content += `<tr><td class="text-left">${infoWindow.dropoffAddress}</td></tr>`;
    }
    // if (infoWindow.dropoffRecipientName) {
    //   content += `<tr><td class="text-left font-semibold"><b>dropoffRecipientName:&nbsp;</b></td><td class="text-left">${infoWindow.dropoffRecipientName}</td></tr>`;
    // }
    // if (infoWindow.userJson && infoWindow.userJson.length > 0 && infoWindow.userJson[0].passengerName) {
    //   content += `<tr><td class="text-left font-semibold"><b>User Name :</b></td><td class="text-left">${infoWindow.userJson[0].passengerName}</td></tr>`;
    // }
    // if (infoWindow.deliveryDateTime) {
    //   content += `<tr><td class="text-left font-semibold"><b>Delivery Time :</b></td><td class="text-left">${infoWindow.deliveryDateTime}</td></tr>`;
    // }
    // if (infoWindow.driverToPickupDistance) {
    //   content += `<tr><td class="text-center">${infoWindow.driverToPickupDistance} ${infoWindow.distanceVariant}</td></tr>`;
    // }
    // content += '</table>';
    return content;
  }
}
